import { combineReducers } from "redux"

import ct from "@constants/"

import user from "./slices/user.slice"
import theme from "./slices/theme.slice"
import chats from "./slices/chats.slice"

const rootReducer = combineReducers({
  [ct.store.USER_STORE]: user,
  [ct.store.THEME_STORE]: theme,
  [ct.store.CHATS_STORE]: chats,
})

export default rootReducer
